import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { LikeButton } from "../../../components/__simple/_likeButton";
import { Price } from "../../../components/__simple/_price";
import { useState } from "react";
import _ from "lodash";
import { useUserFavorite } from "../../../User/hooks/useUserFavorite";
import config from "../../../configuration/config";
import { useUserCart } from "../../../User/hooks/useUserCart";

/**
 * Part Component
 * Displays an individual spare part as a card.
 * Styled via: src/pages/parts/css/part.css
 */
export function Part(props) {
  const { t: trans } = useTranslation(["common", "eparts", "info"]);
  const { changeFavoriteItemState, isFavoriteItem } = useUserFavorite();
  const { changecartItem } = useUserCart();

  const [lang] = useState(localStorage.getItem("i18nextLng"));
  const languageDir = "language-" + localStorage.getItem("i18nextLng");

  let Description = lang === "ar" ? props.DescriptionAr : props.DescriptionEn;

  let imagePath = lang === "ar" ? "/assets/images/parts/PARTS_TOYOTA-AR-no-img.png" : "/assets/images/parts/PARTS_TOYOTA-EN-no-img.png";
  imagePath = props.ProductImage ? config.mainURL + props.ProductImage : imagePath;

  const hasDiscount = props.SalesPriceBefor && props.SalesPriceBefor > 0;

  function handleAddToCart(e) {
    e.preventDefault();
    e.stopPropagation();

    if (props.Qty <= 0) return;

    const objectCart = {
      id: props?.ProductID,
      productID: props?.ProductID,
      name: props?.DescriptionAr,
      nameEn: props?.DescriptionEn,
      price: props?.NetSalePrice,
      image: imagePath,
      Type: "part",
    };
    changecartItem(props?.ProductID, null, null, 1, null, null, objectCart);
  }

  return (
    <div className={"part-card " + (props.extraClass || "")}>
      {/* 1. Favorite & Discount Overlay */}
      <div className="relative w-full">
        {/* Favorite toggle */}
        <LikeButton favorite={Boolean(isFavoriteItem(props.ProductID))} onToggle={() => changeFavoriteItemState(props.ProductID)} />

        {/* Discount badge */}
        {hasDiscount && <div className="discount-badge">{trans("common:offer")}</div>}

        {/* Product Image */}
        <Link to={"/parts/detail/" + props.GUID} className="part-img-link">
          <div className="part-img">
            <img
              src={imagePath}
              alt={Description || "part"}
              loading="lazy"
              onError={(e) => {
                e.target.src = lang === "ar" ? "/assets/images/parts/PARTS_TOYOTA-AR-no-img.png" : "/assets/images/parts/PARTS_TOYOTA-EN-no-img.png";
              }}
            />
          </div>
        </Link>
      </div>

      {/* 2. Content Area */}
      <div className={"part-card-info " + languageDir}>
        {/* SKU / Part No */}
        <div className="part-no">
          <p dir="ltr">#{props.ProductNo}</p>
        </div>

        {/* Description / Name */}
        <Link to={"/parts/detail/" + props.GUID} className="part-description-link">
          <h3 className="part-name text-line-clamp-2">{Description}</h3>

          {/* Price display */}
          <div className="part-price-row">
            {hasDiscount ? (
              <div className="price-container">
                <span className="part-price">
                  <Price price={props.NetSalePrice} />
                </span>
                <span className="original-price">
                  {props.SalesPriceBefor} {trans("common:rial")}
                </span>
              </div>
            ) : (
              <span className="part-price">
                <Price price={props.NetSalePrice} />
              </span>
            )}
          </div>
        </Link>

        {/* 3. Action Button */}
        <div onClick={handleAddToCart} className={`part-card-info-cart  btn ${props.Qty > 0 ? "btn-primary  cursor-pointer" : "btn-black text-white opacity-50  cursor-not-allowed"}`}>
          <span className={`  ${props.Qty > 0 ? " text-black " : " text-white "}`}> {props.Qty > 0 ? trans("info:add_to_cart") : trans("new:not_available")}</span>
          <img className="cart-icon filter-white" src="/assets/icons/cart.svg" alt={trans("buy")} loading="lazy" onError={(e) => (e.target.style.display = "none")} />
        </div>
      </div>
    </div>
  );
}
